import { render, staticRenderFns } from "./SwipeCard.vue?vue&type=template&id=124f9c0f&scoped=true"
import script from "./SwipeCard.vue?vue&type=script&lang=js"
export * from "./SwipeCard.vue?vue&type=script&lang=js"
import style0 from "./SwipeCard.vue?vue&type=style&index=0&id=124f9c0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f9c0f",
  null
  
)

export default component.exports